"use client"

import { forwardRef } from "react"
import ReactPlayer from "react-player"
import { Box, Typography, Paper, Avatar, IconButton, Stack } from "@mui/material"
import { ThumbUp, ThumbDown, Comment, Share, MoreVert } from "@mui/icons-material"
import moment from "moment"

const VideoCard = forwardRef(
  (
    {
      title,
      videoPath,
      handleLikeVideo,
      subTitle,
      likes = 0,
      maintitle,
      date = new Date(),
      view = 0,
      videoId,
      onPlay,
      alumniData = {},
      onPause,
      isPlaying = false,
      liked,
      comments = 0,
    },
    ref,
  ) => {
    return (
      <Paper
        elevation={3}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
          height: "100%",
          width: "100%",
          maxWidth: "400px",
          mb: 3,
          bgcolor: "#ffffff",
          transition: "transform 0.2s",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: 6,
          },
        }}
      >
        {/* Video Player with Action Buttons - Using 9:16 aspect ratio for shorts */}
        <Box
          sx={{
            position: "relative",
            paddingTop: "177.78%", // 9:16 aspect ratio for vertical video
            backgroundColor: "#000",
          }}
        >
          <ReactPlayer
            ref={ref}
            url={videoPath}
            controls
            playing={isPlaying}
            width="100%"
            height="100%"
            style={{ position: "absolute", top: 0, left: 0 }}
            onPlay={() => onPlay(videoId)}
            onPause={onPause}
            onEnded={onPause}
            config={{
              file: {
                attributes: {
                  controlsList: "nodownload",
                  disablePictureInPicture: false,
                },
              },
            }}
          />

          {/* Right side vertical action buttons */}
          <Stack
            direction="column"
            spacing={1.5}
            sx={{
              position: "absolute",
              right: 16,
              bottom: 80,
              zIndex: 10,
              alignItems: "center",
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <IconButton
                onClick={() => handleLikeVideo(videoId)}
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                  width: 40,
                  height: 40,
                }}
              >
                <ThumbUp fontSize="small" color={liked ? "primary" : "inherit"} />
              </IconButton>
              <Typography variant="caption" sx={{ color: "white", mt: 0.5, fontWeight: "bold" }}>
                {likes >= 1000 ? `${(likes / 1000).toFixed(0)}K` : likes}
              </Typography>
            </Box>

            {/* <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <IconButton
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                  width: 40,
                  height: 40,
                }}
              >
                <ThumbDown fontSize="small" />
              </IconButton>
              <Typography variant="caption" sx={{ color: "white", mt: 0.5, fontWeight: "bold" }}>
                Dislike
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <IconButton
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                  width: 40,
                  height: 40,
                }}
              >
                <Comment fontSize="small" />
              </IconButton>
              <Typography variant="caption" sx={{ color: "white", mt: 0.5, fontWeight: "bold" }}>
                {comments >= 1000 ? `${(comments / 1000).toFixed(1)}K` : comments}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <IconButton
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                  width: 40,
                  height: 40,
                }}
              >
                <Share fontSize="small" />
              </IconButton>
              <Typography variant="caption" sx={{ color: "white", mt: 0.5, fontWeight: "bold" }}>
                Share
              </Typography>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
              <IconButton
                sx={{
                  backgroundColor: "rgba(0, 0, 0, 0.6)",
                  color: "white",
                  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.8)" },
                  width: 40,
                  height: 40,
                }}
              >
                <MoreVert fontSize="small" />
              </IconButton>
            </Box> */}
          </Stack>
        </Box>

        {/* Video Info */}
        <Box sx={{ p: 2 }}>
          {/* Title */}
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: "bold",
              lineHeight: 1.2,
              mb: 1.5,
              display: "-webkit-box",
              overflow: "hidden",
              WebkitBoxOrient: "vertical",
              WebkitLineClamp: 2,
            }}
          >
            {maintitle || title}
          </Typography>

          {/* Channel Info */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
            <Avatar
              src={alumniData?.avatar?.data ? `data:image/*;base64, ${alumniData.avatar.data}` : null}
              sx={{ width: 36, height: 36, mr: 1.5 }}
              alt={subTitle || "Channel"}
            />
            <Box>
              <Typography variant="body2" fontWeight="medium">
                {subTitle || "Channel name"}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {view.toLocaleString()} views • {moment(date).format('DD/MM/YYYY')}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    )
  },
)

VideoCard.displayName = "VideoCard"

export default VideoCard
